/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    /// is onscreen function
    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };

    /*! Pushy - v1.1.0 - 2017-1-30
* Pushy is a responsive off-canvas navigation menu using CSS transforms & transitions.
* https://github.com/christophery/pushy/
* by Christopher Yee */

    (function ($) {
        var pushy = $('.pushy'), //menu css class
            body = $('body'),
            container = $('#container'), //container css class
            push = $('.push'), //css class to add pushy capability
            pushyLeft = 'pushy-left', //css class for left menu position
            pushyOpenLeft = 'pushy-open-left', //css class when menu is open (left position)
            pushyOpenRight = 'pushy-open-right', //css class when menu is open (right position)
            siteOverlay = $('.site-overlay'), //site overlay
            menuBtn = $('.menu-btn, .pushy-link'), //css classes to toggle the menu
            menuBtnFocus = $('.menu-btn'), //css class to focus when menu is closed w/ esc key
            menuLinkFocus = $(pushy.data('focus')), //focus on link when menu is open
            menuSpeed = 200, //jQuery fallback menu speed
            menuWidth = pushy.width() + 'px', //jQuery fallback menu width
            submenuClass = '.pushy-submenu',
            submenuOpenClass = 'pushy-submenu-open',
            submenuClosedClass = 'pushy-submenu-closed',
            submenu = $(submenuClass);

        //close menu w/ esc key
        $(document).keyup(function(e) {
            //check if esc key is pressed
            if (e.keyCode == 27) {

                //check if menu is open
                if( body.hasClass(pushyOpenLeft) || body.hasClass(pushyOpenRight) ){
                    if(cssTransforms3d){
                        closePushy(); //close pushy
                    }else{
                        closePushyFallback();
                        opened = false; //set menu state
                    }

                    //focus on menu button after menu is closed
                    if(menuBtnFocus){
                        menuBtnFocus.focus();
                    }

                }

            }
        });

        function togglePushy(){
            //add class to body based on menu position
            if( pushy.hasClass(pushyLeft) ){
                body.toggleClass(pushyOpenLeft);
            }else{
                body.toggleClass(pushyOpenRight);
            }

            //focus on link in menu after css transition ends
            if(menuLinkFocus){
                pushy.one('transitionend', function() {
                    menuLinkFocus.focus();
                });
            }

        }

        function closePushy(){
            if( pushy.hasClass(pushyLeft) ){
                body.removeClass(pushyOpenLeft);
            }else{
                body.removeClass(pushyOpenRight);
            }
        }

        function openPushyFallback(){
            //animate menu position based on CSS class
            if( pushy.hasClass(pushyLeft) ){
                body.addClass(pushyOpenLeft);
                pushy.animate({left: "0px"}, menuSpeed);
                container.animate({left: menuWidth}, menuSpeed);
                //css class to add pushy capability
                push.animate({left: menuWidth}, menuSpeed);
            }else{
                body.addClass(pushyOpenRight);
                pushy.animate({right: '0px'}, menuSpeed);
                container.animate({right: menuWidth}, menuSpeed);
                push.animate({right: menuWidth}, menuSpeed);
            }

            //focus on link in menu
            if(menuLinkFocus){
                menuLinkFocus.focus();
            }
        }

        function closePushyFallback(){
            //animate menu position based on CSS class
            if( pushy.hasClass(pushyLeft) ){
                body.removeClass(pushyOpenLeft);
                pushy.animate({left: "-" + menuWidth}, menuSpeed);
                container.animate({left: "0px"}, menuSpeed);
                //css class to add pushy capability
                push.animate({left: "0px"}, menuSpeed);
            }else{
                body.removeClass(pushyOpenRight);
                pushy.animate({right: "-" + menuWidth}, menuSpeed);
                container.animate({right: "0px"}, menuSpeed);
                push.animate({right: "0px"}, menuSpeed);
            }
        }

        function toggleSubmenu(){
            //hide submenu by default
            $(submenuClass).addClass(submenuClosedClass);

            $(submenuClass).on('click', function(){
                var selected = $(this);

                if( selected.hasClass(submenuClosedClass) ) {
                    //hide opened submenus
                    $(submenuClass).addClass(submenuClosedClass).removeClass(submenuOpenClass);
                    //show submenu
                    selected.removeClass(submenuClosedClass).addClass(submenuOpenClass);
                }else{
                    //hide submenu
                    selected.addClass(submenuClosedClass).removeClass(submenuOpenClass);
                }
            });
        }

        //checks if 3d transforms are supported removing the modernizr dependency
        var cssTransforms3d = (function csstransforms3d(){
            var el = document.createElement('p'),
                supported = false,
                transforms = {
                    'webkitTransform':'-webkit-transform',
                    'OTransform':'-o-transform',
                    'msTransform':'-ms-transform',
                    'MozTransform':'-moz-transform',
                    'transform':'transform'
                };

            if(document.body !== null) {
                // Add it to the body to get the computed style
                document.body.insertBefore(el, null);

                for(var t in transforms){
                    if( el.style[t] !== undefined ){
                        el.style[t] = 'translate3d(1px,1px,1px)';
                        supported = window.getComputedStyle(el).getPropertyValue(transforms[t]);
                    }
                }

                document.body.removeChild(el);

                return (supported !== undefined && supported.length > 0 && supported !== "none");
            }else{
                return false;
            }
        })();

        if(cssTransforms3d){
            //toggle submenu
            toggleSubmenu();

            //toggle menu
            menuBtn.on('click', function(){
                togglePushy();
            });
            //close menu when clicking site overlay
            siteOverlay.on('click', function(){
                togglePushy();
            });
        }else{
            //add css class to body
            body.addClass('no-csstransforms3d');

            //hide menu by default
            if( pushy.hasClass(pushyLeft) ){
                pushy.css({left: "-" + menuWidth});
            }else{
                pushy.css({right: "-" + menuWidth});
            }

            //fixes IE scrollbar issue
            container.css({"overflow-x": "hidden"});

            //keep track of menu state (open/close)
            var opened = false;

            //toggle submenu
            toggleSubmenu();

            //toggle menu
            menuBtn.on('click', function(){
                if (opened) {
                    closePushyFallback();
                    opened = false;
                } else {
                    openPushyFallback();
                    opened = true;
                }
            });

            //close menu when clicking site overlay
            siteOverlay.on('click', function(){
                if (opened) {
                    closePushyFallback();
                    opened = false;
                } else {
                    openPushyFallback();
                    opened = true;
                }
            });
        }
    }(jQuery));


    var scrollTimeout;
    var throttle = 50;

    function scroll_function(scroll) {
        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                var st = $(this).scrollTop();

                checkDivs();

                scrollTimeout = null;
            }, throttle);
        }

        lazy();
    }

    scroll_function($(window).scrollTop());

    if($(window).scrollTop() > 300){
        $('header').addClass('scrollanim');
        $('header').addClass('scroll');
        $('header nav').addClass('nav-down');
    }

    /// Scroll animations
    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();
        scroll_function(scroll);

        if(scroll > 300){
            $('header').addClass('scrollanim');
            $('header').addClass('scroll');
        }else{
            $('header').removeClass('scroll');
            $('header').removeClass('scrollanim');
        }

        $('.scrollDiv.start').each(function () {
            if ($(this).isOnScreen()) {
            }
        });

        lazy();
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }
    lazy();

    var checkDivs = function () {
        $('.anim.start').each(function () {
            if ($(this).isOnScreen() === true) {
                var anim = $(this).attr('data-anim');
                var speed = $(this).attr('data-speed');
                var delay = $(this).attr('data-delay');

                if (speed === null) {
                    speed = 700;
                }

                if (anim === 'fadeUp') {
                    $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeDown') {
                    $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeLeft') {
                    $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeRight') {
                    $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeIn') {
                    $(this).velocity({opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({opacity: 1}, {duration: speed, delay: delay});
                }

            }
        });
    };

    $('.anim').each(function () {
        $(this).addClass('start').css('opacity', 0);
    });

    /// load foundation
    $(document).foundation();

    /// Scroll animations
    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();

        $('.scrollDiv.start').each(function () {
            if ($(this).isOnScreen()) {

            }
        });

        lazy();
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }
    lazy();

    $(window).on('scroll', function() {
        if($(window).scrollTop() > 80){
            $('header nav').addClass('nav-down');
            $('.header-nav__logo img').attr('src', theme_directory + '/source/images/logo-dark.png');
        } else {
            $('header nav').removeClass('nav-down');
            $('.header-nav__logo img').attr('src', theme_directory +  '/source/images/logo.png');
        }
    });

    // usps-wrap

    $('.hero__checks').slick({
        dots: false,
        infinite: true,
        arrows: false ,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.header-overlay').click(function(){
        $(this).fadeOut();
        $('.header-nav__links').removeClass('active');
    });

$('.menu-btn').click(function(){
   $('.header-overlay').fadeIn();
   $('.header-nav__links').addClass('active');
});

    $('.image-slider').slick({
        dots: false,
        infinite: false,
        arrows: true ,
        speed: 300,
        prevArrow: '<span class="slick-prev"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></i></span>',
        nextArrow: '<span class="slick-next"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></span>',
        slidesToShow: 2,
        slidesToScroll: 2,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.liquid').imgLiquid();

    $('.mpartners-single').matchHeight();
    $('.archive-mh').matchHeight();
    $('.blog-ac-titel-mh').matchHeight();

    $('.filter-single').click(function(){
        $('.filter-single.active').removeClass('active');
        $(this).addClass('active');

       var data = $(this).attr('data-filter');

       if(data != 'all'){
           $('.single-equip').addClass('filter');
           $('.single-equip').removeClass('active');
           $('.type-' + data + '').addClass('active');
       }else{
           $('.single-equip').removeClass('filter');
           $('.single-equip').removeClass('active');
       }
    });

    function partnerSlider(){
        $('.partner-wrap').slick({
            dots: false,
            infinite: false,
            arrows: false ,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    if ($(window).width() < 1030) {
        partnerSlider();
    }

    $( window ).resize(function() {
        if ($(window).width() < 1030) {
            partnerSlider();
        }
    });


})(jQuery); // Fully reference jQuery after this point.